import './ProductCard.less';
import React, {useState, useEffect} from 'react';
import Products from "../../../models/product/Products";
import __ from "../../../i18n";
import Icon from '../../../components/icon/Icon';
import ProductImageView from "../product-image-view/ProductImageView";


export default function ProductCard({promoProduct, avatarImage, hoverImage = null, brand = null}) {

    return <a
        className="product-card"
        href={Products.getUrl(promoProduct)}
        title={promoProduct.name}
    >
        <div className="image-container">
            <ProductImageView
                avatarImage={avatarImage}
                hoverImage={hoverImage}
            />
        </div>
        <div className="info-block">
            {
                brand !== null &&
                <div className="brand">{brand.name}</div>
            }
            <div className="name">{promoProduct.name}</div>
            <div className="divider"/>
            <div className="price">
                {
                    promoProduct.is_price_public
                        ? __(':price(CURRENCY)', {price: promoProduct.sale_price})
                        : __('Contact for price')
                }
            </div>
        </div>
        <div className="tags">
            {
                promoProduct.discount_percentage &&
                <>
                    <div className="tag">
                        <span>{__('-:percent%', {percent: promoProduct.discount_percentage})}</span>
                    </div>
                    <div className="tag">
                        <Icon name="gift"/>
                    </div>
                </>
            }
        </div>
    </a>;
}
